import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import UrlUtil from '../../utils/url-util.service';
import Session from '../../utils/session.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatSidenavModule, MatDrawer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'drawer-instructions',
	templateUrl: './drawer-instructions.component.html',
	imports: [ CommonModule, MatSidenavModule, TranslatePipe, FormsModule ]
})
export class DrawerInstructionsComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private session: Session = inject(Session);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@ViewChild('mainDrawer') mainDrawer: MatDrawer;
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.initialized = false;
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, "openMainDrawer", (event, data) => {
					this.vm.isOpen = !this.vm.isOpen;
					if (this.vm.isOpen) {
						this.angularStateHelperService.setGlobalProperty('noDocScroll', true);
						this.swapScroller(true);
						this.mainDrawer.open();
					} else {
						this.close();
					}
				})
		);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Session.LOGIN, (event, data) => {
					this.vm.urls = {
						avTest: this.urlUtil.createAvTestUrl()
					};
					var user: any = this.session.getSession().user;
					if (!user.businessUser) this.vm.initialized = true;
				})
		);
		
		this.vm.close = this.close;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}

	close() {
		this.angularStateHelperService.setGlobalProperty('noDocScroll', false);
		this.swapScroller(false);
		this.mainDrawer.close();
	}
	
	swapScroller(value) {
		if (value) {
			document.body.classList.add("u-no-scroll");
		} else {
			document.body.classList.remove("u-no-scroll");
		}
	}
	
}